import { faCalendar, faUser } from '@fortawesome/free-regular-svg-icons';
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetTypes } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import { Tooltip } from 'antd';
import moment from 'moment';
import React from 'react';


type PropType = {
  widget: any;
  isPreview?: boolean;
  count?: number;
  type: WidgetTypes
}

function renderUsersSelected(props: any) {
  if (props.widget && props.widget.userIds) {
    return (
      <>
        <span className='count-user-style'>{props.widget.userIds.length + '  '}</span>
        {props.widget.userIds.length === 1 &&
          <span >{I18n.l('dashboard.personSelect')}</span>
        }
        {props.widget.userIds.length > 1 &&
          <span >{I18n.l('dashboard.peopleSelect')}</span>
        }
      </>
    )
  }
  else return (
    <span className='span-style'>{I18n.l('dashboard.allUsers')}</span>
  )
}

function renderDateSelected(props: any) {
  if (props.widget) {
    if (props.widget.frequency) {
      let frequencyType = ''
      switch (props.widget.frequency.type) {
        case 1:
          frequencyType = 'frequency.days'
          break
        case 2:
          frequencyType = 'frequency.months'
          break
        case 3:
          frequencyType = 'frequency.years'
          break
        case 4:
          frequencyType = 'frequency.hours'
          break
        case 5:
          frequencyType = 'frequency.minutes'
          break
      }
      return (
        <>
          <span className='count-user-style'>{props.widget.frequency.times + '  '}</span>
          <span >{I18n.l(frequencyType)}</span>
        </>
      )
    }
    else {

      const from = new Date(props.widget.specific.from)
      const to = new Date(props.widget.specific.to)
      const newFrom = moment(from).format(I18n.l('common.dateFormat'))
      const newTo = moment(to).format(I18n.l('common.dateFormat'))
      return (
        <span className='count-user-style'>{newFrom + ' à ' + newTo} </span>
      )
    }
  }
  else return <span className='span-style'>{I18n.l('dashboard.allDays')}</span>;
}


const AditionalContent = (props: PropType) => {
  return (
    <>
      {(props.type === WidgetTypes.LINE_CHART) &&
        <div className={'selected-style'}>
          <FontAwesomeIcon icon={faCalendar} />
          {renderDateSelected(props)}
          <span className='pipe-style'>{'|'}</span>
          <FontAwesomeIcon icon={faUser} />
          {renderUsersSelected(props)}
          <span className='pipe-style'>{'|'}</span>
          <FontAwesomeIcon icon={faTasks} />
          <span className='count-user-style'>{props.count}</span>
          <span className='span-style'>{I18n.l('dashboard.executionsProcess')}</span>
        </div>
      }
      {props.type === WidgetTypes.COUNTER &&
        <div className={props.isPreview ? 'selected-style-preview' : 'selected-style'}>
          <Tooltip title={renderDateSelected(props)}>
            <FontAwesomeIcon className='icon-style' icon={faCalendar} />
          </Tooltip>
          <Tooltip title={renderUsersSelected(props)}>
            <FontAwesomeIcon icon={faUser} />
          </Tooltip>
        </div>
      }
      {(props.type === WidgetTypes.LIST) &&
        <div className={'selected-style'}>
          <Tooltip title={renderDateSelected(props)}>
            <FontAwesomeIcon className='icon-style' icon={faCalendar} />
          </Tooltip>
          <Tooltip title={renderUsersSelected(props)}>
            <FontAwesomeIcon className='icon-style' icon={faUser} />
          </Tooltip>
          <Tooltip title={props.count + ' ' + I18n.l('dashboard.answersProcess')}>
            <FontAwesomeIcon icon={faTasks} />
          </Tooltip>
        </div>
      }
    </>
  )
}
export default AditionalContent
